import React, { useEffect, useRef, useState } from 'react';
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheMissionBriefing() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="the-mission-briefing" ref={ref} className="dark bg-background text-foreground relative w-full overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-5 min-h-[700px]">
                {}
                <div className="relative lg:col-span-3 h-[500px] lg:h-auto w-full overflow-hidden bg-muted">
                    <div className={cn("absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570849/img/veteran_horizon_bw.png)] bg-cover bg-center bg-no-repeat grayscale contrast-125 transition-transform duration-1000 ease-out will-change-transform", isVisible ? "scale-100" : "scale-110")} />
                    {}
                    <div className="absolute inset-0 bg-black/20 lg:bg-transparent" />
                    
                    {}
                    <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-background to-transparent hidden lg:block" />
                    {}
                    <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-background to-transparent lg:hidden" />
                </div>

                {}
                <div className="lg:col-span-2 flex flex-col justify-center px-6 py-16 lg:px-16 lg:py-24 bg-background relative z-10">
                    <div className={cn("space-y-8 transition-all duration-1000 delay-300 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
                        {}
                        <div className="flex items-center gap-4">
                            <div className="h-0.5 w-12 bg-primary shadow-[0_0_10px_rgba(179,0,0,0.5)]" />
                            <span className="text-primary font-bold tracking-[0.2em] uppercase text-sm drop-shadow-sm">
                                Mission Briefing
                            </span>
                        </div>

                        {}
                        <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.1] text-white tracking-tight">
                            Why Paniolo Trails Exists
                        </h2>

                        {}
                        <p className="text-lg md:text-xl text-muted-foreground leading-relaxed max-w-prose border-l-2 border-primary/20 pl-6">
                            Paniolo Trails was founded by veterans and first responders who know the fight doesn’t always end when the uniform comes off. Our mission is to build a community that supports those battling their inner demons and to raise awareness around veteran and first responder suicide.
                        </p>

                        {}
                        <div className="pt-10 mt-4">
                            <div className="relative w-48 h-24 opacity-90 invert dark:invert-0">
                                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570849/img/founders_signature_white.png" alt="Founders Signature" className="object-contain w-full h-full" />
                            </div>
                            <p className="text-sm font-medium text-muted-foreground tracking-wider uppercase mt-2">
                                The Founders
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>;
}